import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { ConsentKeys, DatadogConfig, Environment, LinksMarketingPixelConfig, sfMap, URLs } from './environments/environment';
import { STAGE } from './app/bdo/enums/stage.enum';
import { AwsAuthConfig } from './app/bdo/models/AwsAuthConfig';
import { ReBaseData } from './app/shared/utils/re-base-data';

const init = async () => {
  const configuration = (await fetch('config/config.json').then((res) => res.json()));
  // Load configuration that is external from build
  Environment.version = {
    branch: configuration.branch,
    revision: configuration.revision
  };
  Environment.stage = configuration.stage;
  Environment.kameleoon = configuration.kameleoon;
  Environment.baseHref = configuration.baseHref;
  Environment.apiTags = configuration.apiTags;
  Environment.branch = configuration.branch;
  Environment.local = configuration.local;
  DatadogConfig.applicationId = configuration?.datadogConfig.applicationId;
  DatadogConfig.clientToken = configuration?.datadogConfig.clientToken;
  DatadogConfig.appVersion = configuration?.datadogConfig.appVersion;
  LinksMarketingPixelConfig.tellja = configuration?.LinksMarketingPixelConfig?.tellja;
  LinksMarketingPixelConfig.affiliate = configuration?.LinksMarketingPixelConfig?.affiliate;
  ConsentKeys.datadog = configuration?.consentKeys?.datadog;
  ConsentKeys.kameleoon = configuration?.consentKeys?.kameleoon;
  ConsentKeys.statistics = configuration?.consentKeys?.statistics;
  Environment.awsAuthConfig = configuration.awsAuthConfig as AwsAuthConfig;
  URLs.backend = configuration.urls.backend;
  URLs.sfLoginUrl.set(sfMap[Environment.stage] + '/login');
  URLs.sfRegisterUrl.set(sfMap[Environment.stage] + '/Register');

	if (Environment.stage !== STAGE.Prod) {
		const toStagingLinks = (obj: Record<string, unknown>) => {
			for (const key of Object.keys(obj)) {
				const value = obj[key];
				if (typeof value === 'string') {
					obj[key] = value
						.replace(/https:\/\/www\.rheinenergie\.com/g, 'https://staging.rheinenergie.com')
						.replace(/https:\/\/web\.cdn\.rheinenergie\.com/g, 'https://web-staging.cdn.rheinenergie.com');
				} else if (value && typeof value === 'object') {
					toStagingLinks(value as Record<string, unknown>);
				}
			}
		};
		toStagingLinks(ReBaseData);
	}

	if ((Environment.stage === STAGE.Prod || Environment.stage === STAGE.Test) && !Environment.local) {
		enableProdMode();
	}

	platformBrowser()
		.bootstrapModule(AppModule, {
			applicationProviders: [provideZoneChangeDetection()],
		})
		.catch(err => console.log(err));
};


init();
